import { combineReducers } from "redux";

import auth from "./auth/reducer";
import mediagroups from "./mediagroups/reducer";
import providers from "./providers/reducer";
import persons from "./persons/reducer";
import segments from "./segments/reducer";
import brands from "./brands/reducer";
import categories from "./categories/reducer";
import products from "./products/reducer";
import producttypes from "./productTypes/reducer";
import accounts from "./accounts/reducer";
import users from "./users/reducer";
import profile from "./profile/reducer";
import campaigns from "./campaigns/reducer";
import transactions from "./transactions/reducer";
import bills from "./bills/reducer";
import balance from "./balance/reducer";
import carts from "./carts/reducer";
import orders from "./orders/reducer";
import messages from "./messages/reducer";
import notifications from "./notifications/reducer";
import menus from "./menus/reducer";
import filters from "./filters/reducer";

const appReducer = combineReducers({
  auth,
  brands,
  categories,
  mediagroups,
  providers,
  persons,
  segments,
  products,
  producttypes,
  accounts,
  users,
  profile,
  campaigns,
  transactions,
  bills,
  balance,
  carts,
  orders,
  messages,
  notifications,
  menus,
  filters
});

const rootReducer = (state, action) => {
  if (action.type === "AUTH_SIGNOUT_SUCCESS") {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/data/reducers.js